import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import {ButtonFavourite} from '../button-favourite';
import {ArtistSchema} from '../../types/schema';

export interface FavouriteArtistButtonCompatProps {
  artist: {
    identity: string;
  };
  size?: number;
  className?: string;
  withLabel?: boolean;
  i18n?: {
    favourite: string;
    unfavourite: string;
  }
}

@inject(deps) @observer
export class FavouriteArtistButtonCompat extends Component<FavouriteArtistButtonCompatProps> {
  render() {
    const { artist, size, withLabel, i18n = FavouriteArtistButtonCompat.i18n } = this.props;
    const { sync, artists, removed } = this.props.model.artistlist;
    const { artistlistFavourites } = this.props.model.env;

    if (!artist) return null;

    let isFavourite = false;

    if (artists[artistlistFavourites].indexOf(artist.identity) !== -1) {
      isFavourite = true;
    }

    if (removed[artistlistFavourites].indexOf(artist.identity) !== -1) {
      isFavourite = false;
    }

    const isSync = sync[artistlistFavourites].indexOf(artist.identity) !== -1;

    const label = withLabel
      ? (isFavourite ? i18n.unfavourite : i18n.favourite)
      : void 0;

    return (
      <ButtonFavourite
        className={this.props.className}
        isFavourite={isFavourite}
        isSync={isSync}
        size={size}
        onClick={this.handleClick.bind(this, isFavourite)}
        label={label}
      />
    )
  }

  handleClick = (isFavourite: boolean, event: React.MouseEvent<any>) => {
    event.preventDefault();
    event.stopPropagation();
    if (!this.props.model.user.user) {
      return this.props.controller.onboarding.openSignUpModal();
    }

    if (isFavourite) {
      this.props.controller.artistlist.unfavourite(this.props.artist.identity);
    } else {
      this.props.controller.artistlist.favourite(this.props.artist.identity);
    }
  };

  static i18n = {
    favourite: 'Favourite',
    unfavourite: 'Unfavourite',
  };
}